import styled from "styled-components/macro"
import FloorplanImage from "@common/components/ResidenceGeneric/FloorplanImage"
import ImageOverlay from "../ImageOverlay"
import { useStore } from "@state/store"

const FloorplanSection = ({ selectedUnit }) => {
  const contentControls = useStore((s) => s.contentControls)

  return (
    <Wrapper className="floorplan">
      <ImageOverlay selectedUnit={selectedUnit} />
      <FloorplanImage unit={selectedUnit} isFav={false} />
    </Wrapper>
  )
}

export default FloorplanSection

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  
  .floorplan-modal {
    height: 80%;
    max-height: 80%;
    width: auto;
    max-width: 50%;
    object-fit: contain;
    border: 2px solid red;
  }
`
